import coturn from "./coturn";
import * as nicepayments from "./nicepayments";

export const plugins = {
    coturn,
    ...nicepayments,
};
